import React from "react";
import "./App.css";
import { Helmet } from 'react-helmet';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/custom-animations/fall-animation.css';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import CountUp from 'react-countup';
import 'animate.css';
import Swal from "sweetalert2";
import 'react-circular-progressbar/dist/styles.css';
import Header from "./Header";
import Footer from "./Footer";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import axios from 'axios';
import ScrollAnimation from 'react-animate-on-scroll';
import Typewriter from "typewriter-effect";
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import DOMPurify from 'isomorphic-dompurify';
import 'react-datepicker/dist/react-datepicker.css';
import AppContext from './AppContext';
import { PUBLIC_BASE_URL } from './apiConfig';
import ConsultationForm from './components/ConsultationForm';

const TEST_RECAPTCHA_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

class App extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);

        this.state = {
            
            Job: [],
            Description: '',
            name: '',
            email: '',
            number: '',
            subject: '',
            message: '',
            toDate: '',
            recaptchaToken: '',
            blog: [],
            formErrors: {},
            setContactFormBool: false,
            show: false,
            isOpen: false,
            isActive: false,
            selectedDate: null,
            isAnimationRunning: true,
            autoplay: true,
            selectedService: null,
            clientfidback: []
        }

        this.recaptchaRef = React.createRef();
        this.recaptchaWidgetId = null;
        this.recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || TEST_RECAPTCHA_SITE_KEY;
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.endDateChange = this.endDateChange.bind(this);
        this.onClickShowdetails = this.onClickShowdetails.bind(this);
        this.maxlengthnumber = this.maxlengthnumber.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.openServiceShowcase = this.openServiceShowcase.bind(this);
        this.closeServiceShowcase = this.closeServiceShowcase.bind(this);
        this.loadRecaptcha = this.loadRecaptcha.bind(this);
        this.renderRecaptcha = this.renderRecaptcha.bind(this);
        this.handleRecaptchaChange = this.handleRecaptchaChange.bind(this);
        this.handleRecaptchaExpired = this.handleRecaptchaExpired.bind(this);

        sessionStorage.setItem("yearOfExp", moment().diff(moment("2017-07-10"), "year").toString());
        sessionStorage.setItem("currentYear", moment().format("YYYY").toString());
        sessionStorage.setItem("HOST_API_URL", `${PUBLIC_BASE_URL}/`);

        
    }
    componentDidMount() {
        this.loadRecaptcha();
    }
    loadRecaptcha() {
        if (!this.recaptchaSiteKey) {
            return;
        }

        if (window.grecaptcha?.render) {
            window.grecaptcha.ready ? window.grecaptcha.ready(this.renderRecaptcha) : this.renderRecaptcha();
            return;
        }

        const scriptSrc = 'https://www.google.com/recaptcha/api.js?render=explicit';
        const existingScript = document.getElementById('google-recaptcha-script');
        if (existingScript) {
            if (existingScript.src.includes('/recaptcha/enterprise.js')) {
                existingScript.remove();
            } else {
                existingScript.addEventListener('load', () => {
                    window.grecaptcha?.ready ? window.grecaptcha.ready(this.renderRecaptcha) : this.renderRecaptcha();
                }, { once: true });
                if (window.grecaptcha?.render) {
                    window.grecaptcha.ready ? window.grecaptcha.ready(this.renderRecaptcha) : this.renderRecaptcha();
                }
                return;
            }
        }

        const script = document.createElement('script');
        script.id = 'google-recaptcha-script';
        script.src = scriptSrc;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            window.grecaptcha?.ready ? window.grecaptcha.ready(this.renderRecaptcha) : this.renderRecaptcha();
        };
        document.body.appendChild(script);
    }
    renderRecaptcha() {
        if (!this.recaptchaRef.current || !window.grecaptcha?.render || this.recaptchaWidgetId !== null) {
            return;
        }

        this.recaptchaWidgetId = window.grecaptcha.render(this.recaptchaRef.current, {
            sitekey: this.recaptchaSiteKey,
            callback: this.handleRecaptchaChange,
            'expired-callback': this.handleRecaptchaExpired,
            'error-callback': this.handleRecaptchaExpired,
        });
    }
    handleRecaptchaChange(token) {
        this.setState((prevState) => ({
            recaptchaToken: token,
            formErrors: {
                ...prevState.formErrors,
                recaptchaError: '',
            },
        }));
    }
    handleRecaptchaExpired() {
        this.setState({ recaptchaToken: '' });
    }

    openModal(e) {
        this.setState({ isOpen: !this.state.isOpen });
    }
    handleOpenContectModal(e) {
        this.setState({ show: !this.state.show });
        //console.log("state is::::::::", this.state.show);
    }
    handlevideopopup(e) {
        //console.log("::::::add on this:");
        this.setState({ isActive: !this.state.isActive });
    }
    onContactFormHide(e) {
        //console.log(" event ::::onContactFormHide:: ", this.state.setContactFormBool);
        this.setState({ setContactFormBool: false });
    }
    onContactFormShow(e) {
        //console.log(" event ::onContactFormShow:::: ", this.state.setContactFormBool);        
        this.setState({ show: !this.state.show })
    }
    onClickShowdetails(job) {
        //console.log("job is:::::::", job);
        localStorage.setItem("Job", JSON.stringify(job));
        window.location.href = '/careerdetail';
    }
    handleChange(e) {
        this.setState({ ...this.state, [e.target.name]: e.target.value })
    }
    endDateChange(e) {
        this.setState({ toDate: e.target.value })
    }
    handleChangedatepicker = (date) => {
        this.setState({
            selectedDate: date,
        });
    };
    onClickblogdetails(blog) {
        //console.log("blog is:::::::", blog);
        localStorage.setItem("Blog", JSON.stringify(blog));
        window.location.href = '/blogdetails';
    }
    closeModal() {
        this.setState({ show: !this.state.show });
    };
    handleClickInsideModal = (event) => {
        event.stopPropagation();
    }
    openServiceShowcase(service) {
        this.setState({ selectedService: service });
    }
    closeServiceShowcase() {
        this.setState({ selectedService: null });
    }
    maxlengthnumber(evt) {
        if (evt.target.value.length === 11) {
            return false;
        }
        else {
            this.setState({ ...this.state, [evt.target.name]: evt.target.value })
        }
    }
    handleScroll() {
        if (window.scrollY > 100) {
            this.setState({ isScrolled: true });
        } else {
            this.setState({ isScrolled: false });
        }
    }
    onSubmit(e) {
        e.preventDefault();
        let formErrors = {};
        const requiresRecaptcha = e.currentTarget.dataset.recaptcha === 'true';
        //console.log("Enter in::::::::::::");
        if (this.state.name === '' || this.state.name === null) {

            formErrors["nameError"] = "Name is required.";
            this.refs.namefield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });
            return false;
        }
        else if (this.state.email === '' || this.state.email === null) {
            formErrors["emailError"] = "Email id is required.";
            this.refs.emailfield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }
        else if (this.state.subject === '' || this.state.subject === null) {
            formErrors["subjectError"] = "Subect is required.";
            this.refs.subjectfield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }
        else if (this.state.number === '' || this.state.number === null) {
            formErrors["numberError"] = "Number is required.";
            this.refs.numberfield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }
        else if (this.state.message === '' || this.state.message === null) {
            formErrors["messageError"] = "Message is required.";
            this.refs.messagefield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        } else if (this.state.toDate === '' || this.state.toDate === null) {
            formErrors["toDateError"] = "Date is required.";
            this.refs.toDatefield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        } else if (requiresRecaptcha && !this.state.recaptchaToken) {
            formErrors["recaptchaError"] = "Please verify that you are not a robot.";
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        } else {

            const formObject = {
                name: this.state.name,
                email: this.state.email,
                number: this.state.number,
                subject: this.state.subject,
                toDate: this.state.toDate,
                message: this.state.message,
                recaptchaToken: this.state.recaptchaToken,

            };
            //console.log("formObject::::::::::;", formObject);
            axios.post("/contactus", formObject)
                .then((res) => {
                    //console.log("Response is:::::::::", res);
                    if (res.data !== 'undefined') {
                        if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                            window.grecaptcha.reset(this.recaptchaWidgetId);
                        }
                        Swal.fire({
                            title: "Thank you!",
                            text: "Your request has been assigned successfully.",
                            icon: "success",
                        }).then(function () {
                            window.location.reload();
                        });
                    } else {
                        if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                            window.grecaptcha.reset(this.recaptchaWidgetId);
                        }
                        Swal.fire({
                            title: "Oops...!",
                            text: "Oh! Something went wrong, please try again!",
                            icon: "error",
                        }).then(function () {
                            window.location.reload();
                        });
                    }

                })
                .catch((error) => {
                    if (window.grecaptcha && this.recaptchaWidgetId !== null) {
                        window.grecaptcha.reset(this.recaptchaWidgetId);
                    }
                    this.setState({ recaptchaToken: '' });
                    Swal.fire({
                        title: "Verification failed",
                        text: error.response?.data?.message || "Please complete reCAPTCHA and try again.",
                        icon: "error",
                    });
                });
        }

    }

    render() {

        const { apiHeaderData, apiCareerData, loading } = this.context;
        
        const sliderSettings = {
            dots: false,
            items: 5,
            slidestoscroll: 1,
            autoplay: true,
            interval: 5000,
            initialslide: 0,
            autoplaytimeout: 8000,
            autoplaySpeed: 2000,
            responsive: {
                0: {
                    items: 2,
                    nav: false
                },
                600: {
                    items: 3,
                    nav: false
                },
                1000: {
                    items: 4,
                    nav: false,
                }
            }           
        }
        const sliderone = {
            dots: false,
            items: 1,
            slidestoscroll: 1,
            autoplay: true,
            interval: 5000,
            initialslide: 0,
            autoplaytimeout: 5000,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        items: 2,
                        slidestoscroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        items: 1,
                        slidestoscroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        items: 1,
                        slidestoscroll: 1,
                        infinite: true,
                        dots: false,
                    }
                }
            ]

        }
        const slidertwo = {
            dots: false,
            items: 1,
            slidestoscroll: 1,
            autoplay: true,
            interval: 2000,
            initialslide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        items: 2,
                        slidestoscroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        items: 1,
                        slidestoscroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        items: 1,
                        slidestoscroll: 1,
                        infinite: true,
                        dots: false,
                    }
                }
            ]

        }
        
        const myStyleone = {
            backgroundImage:
                "url('../assets/img/bg/hero-bg/UGS-Web-Hero.jpg')",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
            opacity: 0.9,
        };
        const mystyletow = {
            backgroundImage:
                "url('../assets/img/bg/hero-bg/slide-bg-performance.jpg')",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2,
            opacity: 0.9,
            backgroundSize: "cover",
        };
        const mystylethree = {
            backgroundImage:
                "url('../assets/img/bg/hero-bg/app.jpg')",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: "0px",
            backgroundSize: "cover",
            left: "0px",
            zIndex: "2",
            opacity: "0.9",
            backgroundPosition: "initial",
        };
        const mystylefour = {
            backgroundImage:
                "url('../assets/img/bg/hero-bg/cta_bg_1.png')",
            background: '#1c1c1c'
        };
        const mystylefive = {
            backgroundImage:
                "url('../assets/img/bg/service_bg_2.jpg')",
            backgroundRepeat: 'no-repeat',
            zIndex: "9"
        }
        const mystylesix = {            
            backgroundColor: "#f3f3f3d4",
            backgroundRepeat: 'no-repeat'
        }
        const settings = {
            /* animateOut: 'flipOutY',
            animateIn: 'flipInY', */
            items: 1,
            loop: true,
            dots: false,
            nav: false,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
        };
        const { nameError, emailError, subjectError, numberError, toDateError, messageError } = this.state.formErrors;
        var Information;
        if (this.state.Job.length) {
            Information = this.state.Job.map((job, Index) =>
                <>
                    <li key={Index}>
                        <a href="#" onClick={() => this.onClickShowdetails(job)}>{job.job}</a>
                    </li>
                </>
            )
        } else {
            Information = <div className="text-center"><h4 style={{ color: "Red", fontSize: "20px" }}>No Record Found !</h4></div>;
        }
        const expertiseItems = [
            { title: "Game Development", href: "/gamedevelopment" },
            { title: "UI/UX Design", href: "/game-ui-design" },
            { title: "Web Development", href: "/webdevelopment" },
            { title: "3D Modeling", href: "/character-modeling" },
            { title: "3D Animations", href: "/character-animation" }
        ];
        const homeServices = [
            {
                title: "Game Development",
                href: expertiseItems[0].href,
                iconType: "image",
                icon: "assets/img/GameDevelopment/Group-1.svg",
                iconAlt: "Game development",
                description: "Unity, Unreal, 2D/3D, multiplayer, mobile, PC, web, console, and AR/VR/MR game production.",
                tags: ["Unity", "Multiplayer"],
                showcaseItems: [
                    { title: "Unity Game Development", href: "/unity" },
                    { title: "Android Game Development", href: "/android" },
                    { title: "iOS Game Development", href: "/ios" },
                    { title: "Web Based Games", href: "/webbased" },
                    { title: "Multiplayer Games", href: "/multiplayer-game-development" },
                    { title: "Mobile, PC & Console Games", href: "/mobile-pc-web-console-game-development" },
                    { title: "AR/VR Games", href: "/ar-vr-game-development" },
                    { title: "Card Games", href: "/Card" },
                    { title: "Casino Games", href: "/Casino" },
                    { title: "Board Games", href: "/Board" },
                    { title: "Puzzle Games", href: "/Puzzle" },
                    { title: "Arcade Games", href: "/Arcarde" },
                    { title: "Action Games", href: "/Action" },
                    { title: "Adventure Games", href: "/Adventure" },
                    { title: "Racing Games", href: "/Racing" },
                    { title: "Casual Games", href: "/Casual" },
                    { title: "Educational Games", href: "/Educational" },
                    { title: "Horror Games", href: "/Horror" },
                    { title: "Music Games", href: "/Music" },
                    { title: "Quiz Games", href: "/Quiz" },
                    { title: "Roguelike Games", href: "/Roguelike" },
                    { title: "RPG Games", href: "/Rpg" },
                    { title: "Sandbox Games", href: "/sendbox" },
                    { title: "Simulator Games", href: "/Simulator" },
                    { title: "Sports Games", href: "/Sport" },
                    { title: "Strategy Games", href: "/Strategy" },
                    { title: "Word Games", href: "/Word" }
                ]
            },
            {
                title: "Mobile App Development",
                href: "/mobiledevelopment",
                iconType: "image",
                icon: "assets/img/icon/service_card_3.svg",
                iconAlt: "Mobile app development",
                description: "Android, iOS, and cross-platform applications with clean interfaces and stable performance.",
                tags: ["Android", "iOS"],
                showcaseItems: [
                    { title: "Android App Development", href: "/android-application-development" },
                    { title: "iOS App Development", href: "/ios-application-development" },
                    { title: "Cross Platform Apps", href: "/cross-platform-app-development" },
                    { title: "Flutter Development", href: "/flutter" },
                    { title: "Mobile App Development", href: "/mobiledevelopment" }
                ]
            },
            {
                title: "UI/UX Design",
                href: expertiseItems[1].href,
                iconType: "class",
                icon: "fa-solid fa-pen-ruler",
                description: "Mobile UI, game UI, wireframes, design systems, clickable prototypes, and product flows.",
                tags: ["Mobile UI", "Game UI"],
                showcaseItems: [
                    { title: "Mobile UI Design", href: "/mobile-ui-design" },
                    { title: "Game UI Design", href: "/game-ui-design" },
                    { title: "Wireframe Design", href: "/wireframe-design" },
                    { title: "Game UI Prototyping", href: "/game-ui-prototyping" },
                    { title: "Game UI Assets", href: "/game-ui-assets" }
                ]
            },
            {
                title: "Web Development",
                href: expertiseItems[2].href,
                iconType: "image",
                icon: "assets/img/icon/service_card_1.svg",
                iconAlt: "Web development",
                description: "Business websites, web applications, admin panels, dashboards, and conversion-focused pages.",
                tags: ["Web Apps", "Dashboards"],
                showcaseItems: [
                    { title: "Business Websites", href: "/business-website-development" },
                    { title: "Web Applications", href: "/web-applications" },
                    { title: "Admin Panels & Dashboards", href: "/admin-panels-dashboards" },
                    { title: "React Development", href: "/reactjs" },
                    { title: "Node.js Development", href: "/nodejs" },
                    { title: "Express.js Development", href: "/expressjs" },
                    { title: "PHP Development", href: "/php" },
                    { title: "CodeIgniter Development", href: "/codelgnitor" }
                ]
            },
            {
                title: "Backend & Cloud Development",
                href: "/nodejs",
                iconType: "class",
                icon: "fa-solid fa-cloud",
                description: "APIs, game servers, multiplayer backend, database design, cloud deployment, and DevOps.",
                tags: ["APIs", "Cloud"],
                showcaseItems: [
                    { title: "Game API Development", href: "/game-api-development" },
                    { title: "Game Server Development", href: "/game-server-development" },
                    { title: "Multiplayer Backend Development", href: "/multiplayer-backend-development" },
                    { title: "Game Database Design", href: "/game-database-design" },
                    { title: "Game Cloud Deployment", href: "/game-cloud-deployment" },
                    { title: "Game DevOps Services", href: "/game-devops-services" },
                    { title: "Node.js Development", href: "/nodejs" },
                    { title: "Express.js Development", href: "/expressjs" }
                ]
            },
            {
                title: "3D Modeling",
                href: expertiseItems[3].href,
                iconType: "class",
                icon: "fa-solid fa-cubes",
                description: "Characters, environments, props, weapons, vehicles, architecture, PBR assets, and UV mapping.",
                tags: ["Characters", "PBR"],
                showcaseItems: [
                    { title: "Character Modeling", href: "/character-modeling" },
                    { title: "Environment Modeling", href: "/environment-modeling" },
                    { title: "Props & Weapons Modeling", href: "/props-weapons-modeling" },
                    { title: "Vehicle Modeling", href: "/vehicle-modeling" },
                    { title: "Architectural Modeling", href: "/architectural-modeling" },
                    { title: "Low Poly & High Poly Assets", href: "/low-poly-high-poly-assets" },
                    { title: "PBR Texturing", href: "/pbr-texturing" },
                    { title: "UV Mapping", href: "/uv-mapping" },
                    { title: "Blender Sculpting", href: "/blender-sculpting" }
                ]
            },
            {
                title: "3D Animations",
                href: expertiseItems[4].href,
                iconType: "class",
                icon: "fa-solid fa-person-running",
                description: "Character animation, creature animation, rigging, skinning, facial animation, mocap cleanup, and cinematics.",
                tags: ["Rigging", "Cinematics"],
                showcaseItems: [
                    { title: "Character Animation", href: "/character-animation" },
                    { title: "Creature Animation", href: "/creature-animation" },
                    { title: "Rigging & Skinning", href: "/rigging-skinning" },
                    { title: "Facial Animation", href: "/facial-animation" },
                    { title: "Motion Capture Cleanup", href: "/motion-capture-cleanup" },
                    { title: "Game Cinematics", href: "/game-cinematics" },
                    { title: "Product Animations", href: "/product-animations" }
                ]
            },
            {
                title: "2D Art & Animation",
                href: "/game-character-design",
                iconType: "class",
                icon: "fa-solid fa-palette",
                description: "Character design, concept art, illustrations, sprite animation, Spine animation, and UI assets.",
                tags: ["Sprites", "Concept Art"],
                showcaseItems: [
                    { title: "Game Character Design", href: "/game-character-design" },
                    { title: "Game Concept Art", href: "/game-concept-art" },
                    { title: "Game Illustrations", href: "/game-illustrations" },
                    { title: "Sprite Animation", href: "/sprite-animation" },
                    { title: "Spine Animation", href: "/spine-animation" },
                    { title: "Game UI Assets", href: "/game-ui-assets" }
                ]
            },
            {
                title: "VFX & Technical Art",
                href: "/game-particle-effects",
                iconType: "class",
                icon: "fa-solid fa-wand-magic-sparkles",
                description: "Particle effects, shader development, lighting, optimization, and technical art support.",
                tags: ["Shaders", "Lighting"],
                showcaseItems: [
                    { title: "Game Particle Effects", href: "/game-particle-effects" },
                    { title: "Game Shader Development", href: "/game-shader-development" },
                    { title: "Game Lighting", href: "/game-lighting" },
                    { title: "Game Art Optimization", href: "/game-art-optimization" }
                ]
            },
            {
                title: "QA & Testing",
                href: "/functional-testing",
                iconType: "class",
                icon: "fa-solid fa-clipboard-check",
                description: "Functional testing, performance testing, device compatibility checks, bug reporting, and bug fixing.",
                tags: ["Performance", "Devices"],
                showcaseItems: [
                    { title: "Functional Testing", href: "/functional-testing" },
                    { title: "Game Functional Testing", href: "/game-functional-testing" },
                    { title: "Bug Fixing", href: "/bug-fixing" },
                    { title: "Game Bug Fixing", href: "/game-bug-fixing" }
                ]
            },
            {
                title: "Live Operations & Support",
                href: "/game-maintenance",
                iconType: "class",
                icon: "fa-solid fa-headset",
                description: "Game maintenance, content updates, analytics, monetization, ad integration, and store publishing.",
                tags: ["LiveOps", "Publishing"],
                showcaseItems: [
                    { title: "Game Maintenance", href: "/game-maintenance" },
                    { title: "Game Content Updates", href: "/game-content-updates" },
                    { title: "Game Analytics", href: "/game-analytics" },
                    { title: "Game Monetization", href: "/game-monetization" },
                    { title: "Game Ad Integration", href: "/game-ad-integration" },
                    { title: "Game Store Publishing", href: "/game-store-publishing" }
                ]
            },
            {
                title: "Emerging Technologies",
                href: "/Service",
                iconType: "class",
                icon: "fa-solid fa-microchip",
                description: "AI integration, machine learning, blockchain/Web3, digital twins, and metaverse solutions.",
                tags: ["AI", "Web3"],
                showcaseItems: [
                    { title: "AI Integration", href: "/Service" },
                    { title: "Machine Learning", href: "/Service" },
                    { title: "Blockchain/Web3", href: "/Service" },
                    { title: "Digital Twins", href: "/Service" },
                    { title: "Metaverse Solutions", href: "/Service" },
                    { title: "Automation Tools", href: "/Service" }
                ]
            }
        ];
        const homeServicesCarousel = {
            loop: true,
            margin: 16,
            nav: true,
            dots: true,
            autoplay: false,
            smartSpeed: 550,
            navText: [
                '<i class="fa-regular fa-arrow-left"></i>',
                '<i class="fa-regular fa-arrow-right"></i>'
            ],
            responsive: {
                0: { items: 1 },
                576: { items: 2 },
                992: { items: 3 },
                1200: { items: 4 },
                1400: { items: 5 }
            }
        };
        const selectedService = this.state.selectedService;
        var latestpostdata;
        if (this.state.blog.length) {
            var latestpostdata = <OwlCarousel className='owl-theme' loop margin={10} {...sliderone} animationdelay="3s" nav>
                {this.state.blog.map((blog, index) => {
                    return <>
                        <article>
                            <div className="row justify-content-center">
                                <div className="col-auto pe-0">
                                    <div className="date latest_date">
                                        {moment(blog.createdat).format('YYYY-MM-DD')}
                                    </div>
                                </div>
                                <div className="col ps-1 col-md-10 col-sm-10 col-12 col-lg-8">
                                    <h4 className="text-primary text-4"><a className="d-block" href="#!" onClick={() => this.onClickblogdetails(blog)} >{blog.blogtitle}
                                    </a>
                                    </h4>
                                    <div className="box" id="section">
                                        <div className="content-full article" id="article" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.sub_title) }}></div>
                                    </div>
                                    <a href="#!" onClick={() => this.onClickblogdetails(blog)} className="read-more text-color-dark font-weight-semibold text-2">read more
                                        <i className="fas fa-angle-right position-relative top-1 ms-1"></i>
                                    </a>
                                </div>
                            </div>
                        </article>

                    </>
                }
                )}
            </OwlCarousel>
        } else {
            latestpostdata = <div><h4 style={{ color: "Red", fontSize: "20px" }}>No Record Found !</h4></div>;
        }

        var clientfideback;
        if (this.state.clientfidback.length) {
            var clientfideback = <OwlCarousel className='owl-theme' loop margin={10} {...slidertwo} nav>
                {this.state.clientfidback.map((clientfidback, index) => {
                    return <>
                        <div>
                            <div className="col">
                                <div className="testimonial testimonial-primary">
                                    <blockquote>
                                        <p className="mb-0">{clientfidback.review}</p>
                                    </blockquote>
                                    <div className="testimonial-arrow-down"></div>
                                    <div className="testimonial-author d-flex">
                                        <div className="testimonial-author-thumbnail">
                                        </div>
                                        <p><strong>{clientfidback.name}</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
                )}
            </OwlCarousel>
        } else {
            clientfideback = <div><h4 style={{ color: "Red", fontSize: "20px" }}>No Record Found !</h4></div>;
        }


        const { selectedDate } = this.state;
        const AutoplaySlider = withAutoplay(AwesomeSlider);
        const { isAnimationRunning } = this.state;
        const pattern = /\/example/;

        return (
            <div>
                <Helmet>
                    <title>Oengines Games LLP | Game, Web & Mobile App Development Company</title>
                    <meta name="description" content="Oengines Games LLP provides game development, mobile app development, web development, backend, cloud, UI/UX, 2D/3D art, animation, QA, and live product support services." />
                    <meta name="keywords" content="game development company, mobile app development company, web development company, Unity game development, Android game development, iOS app development, web based game development, multiplayer game development, board game development, card game development, Oengines Games LLP" />
                    <link rel="canonical" href="https://www.oengines.com/" />
                    <meta property="og:title" content="Oengines Games LLP | Game, Web & Mobile App Development Company" />
                    <meta property="og:description" content="Build custom games, web platforms, and mobile apps with Oengines Games LLP. We develop Unity games, web-based games, Android apps, iOS apps, and multiplayer game solutions." />
                    <meta property="og:url" content="https://www.oengines.com/" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://www.oengines.com/assets/img/logo1.png" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Oengines Games LLP | Game, Web & Mobile App Development Company" />
                    <meta name="twitter:description" content="Game, mobile app, web, backend, art, animation, QA, and live product support services from Oengines Games LLP." />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "Organization",
                            "name": "Oengines Games LLP",
                            "url": "https://www.oengines.com/",
                            "logo": "https://www.oengines.com/assets/img/logo1.png",
                            "email": "support@oengines.com",
                            "telephone": "+91-261-4054978",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "436, Amby Vally Arcade, Utran",
                                "addressLocality": "Surat",
                                "addressRegion": "Gujarat",
                                "addressCountry": "IN"
                            },
                            "sameAs": [
                                "https://www.facebook.com/oe.studio091",
                                "https://www.linkedin.com/company/oenginesgames",
                                "https://www.youtube.com/@oenginesstudio337"
                            ]
                        })}
                    </script>
                    <link href="https://owlcarousel2.github.io/OwlCarousel2/assets/css/animate.css" rel="stylesheet" />
                    {/* <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.2.0/assets/owl.theme.default.css" />
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.2.0/assets/owl.carousel.css" />      */}           
                    <link rel="stylesheet" href="../assets/css/Slick_Cdn/animate.min.css" />
                    <link rel="stylesheet" href="../assets/css/Slick_Cdn/Datepicker.css" />                    
                    <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css" />
                    <link rel="stylesheet" href="../../assets/css/Slick_Cdn/Slic-min.css" />                    
                    <script src="../assets/js/jquery-min.js"></script>
                    <script src="../assets/js/Tweenlite-min.js"></script>
                    <script src="../assets/js/raf.js"></script>
                    <script src="../assets/js/easepack-min.js"></script>
                    <script src="../assets/js/tsparticle-engine.js"></script>
                    <script src="../assets/js/tsparticles-bundle.js"></script>
                    <script src="../assets/js/jquery-particles.js"></script>
                    <script src="../assets/js/tsparticles-min.js"></script>
                    <script src="../assets/js/slick-min.js"></script>
                    <script src="../assets/js/tsparticles-min.js"></script>
                    <script src="../assets/js/particles-min.js"></script>
                    <script src="../assets/js/jquery-min-2.1.3.js"></script>
                    <script src="../assets/js/Datetimepicker.full.min.js"></script>                   
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.0/jquery.min.js" type="javascript"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.2.0/owl.carousel.js" type="javascript"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/js/bootstrap.min.js" type="javascript"></script>
                    <script src="../assets/js/script.js" type="text/Javascript"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/1.12.4/jquery.min.js" type="text/Javascript"></script>
                    <script src="https://owlcarousel2.github.io/OwlCarousel2/assets/owlcarousel/owl.carousel.js" type="text/Javascript"></script>
                </Helmet>
                {loading && (
                    <div className="page-loader" role="status" aria-live="polite" aria-busy="true">
                        <div className="loader-backdrop" />
                        <div className="loader-card">
                            <div className="loader-logo-wrap">
                                <img className="loader-logo" src="/assets/img/white-logo.png" alt="Oengines" />
                            </div>
                            <div className="loader-orbit" aria-hidden="true">
                                <span className="loader-core" />
                                <span className="loader-ring ring-1" />
                                <span className="loader-ring ring-2" />
                                <span className="loader-ring ring-3" />
                            </div>
                            <div className="loader-text">
                                <span className="loader-brand">Loading</span>
                                <span className="loader-sub">Preparing your experience</span>
                            </div>
                            <div className="loader-bars">
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                )}

                <Modal show={this.state.show} onClick={this.handleClickInsideModal} className="modal_contect" centered >
                    <Modal.Header closeButton onHide={(e) => this.handleOpenContectModal()}>
                        <h5 className="modal-title m-auto" id="exampleModalLabel">ContactUs</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.onSubmit} method="post" className="contact-form ajax-contact">
                            <div className="row">
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="text" ref="namefield" className={nameError ? "form-control is-invalid" : "form-control"} name="name" id="name" placeholder="Your Name" onChange={this.handleChange} autoComplete="Off" />
                                    <i className="fal fa-user"></i>
                                    {nameError &&
                                        <div className="invalid-feedback" >{nameError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="email" className={emailError ? "form-control is-invalid" : "form-control"} ref="emailfield" name="email" id="email" placeholder="Email Address" onChange={this.handleChange} autoComplete="Off" />
                                    <i className="fal fa-envelope"></i>
                                    {emailError &&
                                        <div className="invalid-feedback">{emailError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <select name="subject" id="subject" ref="subjectfield" className={subjectError ? "form-control is-invalid" : "form-control"} onChange={this.handleChange} autoComplete="Off">
                                        <option disabled="disabled">Select Subject
                                        </option>
                                        <option defaultValue={"Web Development"}>Web Development</option>
                                        <option defaultValue={"Brand Marketing"}>Brand Marketing</option>
                                        <option defaultValue={"UI/UX Designing"}>UI/UX Designing</option>
                                        <option defaultValue={"Digital Marketing"}>Digital Marketing</option>
                                    </select>
                                    {subjectError &&
                                        <div className="invalid-feedback">{subjectError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="number" className={numberError ? "form-control is-invalid" : "form-control"} name="number" ref="numberfield" id="number" placeholder="Phone Number" autoComplete="Off" maxLength={10} onChange={this.maxlengthnumber} value={this.state.number} />
                                    <i className="fal fa-phone"></i>
                                    {numberError &&
                                        <div className="invalid-feedback">{numberError}</div>
                                    }
                                </div>
                                <div className="form-group col-12">
                                    <input className="form-control datetimepickerone d-desktop" id="datetimepickerone" name="toDate" onBlur={this.endDateChange} type="text" ref="toDatefield" autoComplete="off" placeholder="Consultation Date" />
                                    <i className="fal fa-calendar"></i>
                                    {toDateError &&
                                        <div className="invalid-feedback">{toDateError}</div>
                                    }
                                </div>

                                <div className="form-group col-12">
                                    <textarea name="message" id="message" cols="30" rows="3" ref="messagefield"
                                        className={messageError ? "form-control is-invalid" : "form-control"} placeholder="Your Message" onChange={this.handleChange} autoComplete="Off">
                                    </textarea>
                                    <i className="fal fa-comment"></i>
                                    {messageError &&
                                        <div className="invalid-feedback">{messageError}</div>
                                    }
                                </div>
                                <div className="form-btn text-xl-start text-center col-12">
                                    <button type="submit" className="as-btn style3 send-qty">Send Details
                                        <i className="fa-regular fa-arrow-right ms-2"></i>
                                    </button>
                                </div>
                            </div>
                            <p className="form-messages mb-0 mt-3"></p>
                        </form>

                    </Modal.Body>
                </Modal>
                <Modal show={this.state.isOpen} onClick={this.handleClickInsideModal} className="modal_contect video-effect-modal" centered>
                    <Modal.Header closeButton onHide={() => this.openModal()}>
                        <h5 className="modal-title m-auto" id="exampleModalLabel">Get A Quote</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.onSubmit} method="post" className="contact-form  quote-form ajax-contact">
                            <div className="row">
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="text" ref="namefield" className={nameError ? "form-control is-invalid" : "form-control"} name="name" id="name" placeholder="Your Name" onChange={this.handleChange} autoComplete="Off" />
                                    <i className="fal fa-user"></i>
                                    {nameError &&
                                        <div className="invalid-feedback" >{nameError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="email" className={emailError ? "form-control is-invalid" : "form-control"} ref="emailfield" name="email" id="email" placeholder="Email Address" onChange={this.handleChange} autoComplete="Off" />
                                    <i className="fal fa-envelope"></i>
                                    {emailError &&
                                        <div className="invalid-feedback">{emailError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <select name="subject" id="subject" ref="subjectfield" className={subjectError ? "form-control is-invalid" : "form-control"} onChange={this.handleChange} autoComplete="Off">
                                        <option disabled="disabled">Select Subject
                                        </option>
                                        <option defaultValue={"App Development"}>App Development</option>
                                        <option defaultValue={"Game Development"}>Game Development</option>
                                        <option defaultValue={"Web Development"}>Web Development</option>
                                        <option defaultValue={"Brand Marketing"}>Brand Marketing</option>
                                        <option defaultValue={"UI/UX Designing"}>UI/UX Designing</option>
                                        <option defaultValue={"Digital Marketing"}>Digital Marketing</option>
                                    </select>
                                    {subjectError &&
                                        <div className="invalid-feedback">{subjectError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="number" className={numberError ? "form-control is-invalid" : "form-control"} name="number" ref="numberfield" id="number" placeholder="Phone Number" autoComplete="Off" maxLength={10} onChange={this.maxlengthnumber} value={this.state.number} />
                                    <i className="fal fa-phone"></i>
                                    {numberError &&
                                        <div className="invalid-feedback">{numberError}</div>
                                    }
                                </div>

                                <div className="form-group col-12">
                                    <textarea name="message" id="message" cols="30" rows="30" ref="messagefield"
                                        className={messageError ? "form-control is-invalid" : "form-control"} placeholder="Your Message" onChange={this.handleChange} autoComplete="Off">
                                    </textarea>
                                    <i className="fal fa-comment"></i>
                                    {messageError &&
                                        <div className="invalid-feedback">{messageError}</div>
                                    }
                                </div>
                                <div className="form-btn text-xl-start text-center col-12">
                                    <button type="submit" className="as-btn style3 send-qty">Send QUOTE
                                        <i className="fa-regular fa-arrow-right ms-2"></i>
                                    </button>
                                </div>
                            </div>
                            <p className="form-messages mb-0 mt-3"></p>
                        </form>
                    </Modal.Body>
                </Modal>
                <Modal size="lg" show={this.state.isActive} onClick={this.handleClickInsideModal} className="modal_contect video-effect-modal modalvideos" centered>
                    <Modal.Header closeButton className="modal_header p-0 border-none" style={{ border: "none" }} onHide={() => this.handlevideopopup()} >
                    </Modal.Header>
                    <Modal.Body>
                        <iframe width="960" height="415" src="https://www.youtube.com/embed/fiwb3PBkZIM?autoplay=1&mute=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </Modal.Body>
                </Modal>
                <Header apiHeaderData={apiHeaderData}/>
               
                <div className="as-hero-wrapper hero-2" id="hero">
                    <div className="hero-slider-2">
                        <OwlCarousel className="owl-theme" {...settings} loop margin={10} items={1}>
                            <div className="as-hero-slide">
                                <div className="as-hero-bg as-hero-bg-one" data-bg-src="../public/assets/img/bg/UGS-Web-Hero.jpg" style={myStyleone}
                                    id="top"></div>
                                <div className="container">
                                    <div className="hero-style2">
                                        <div className="ripple-shape"><span className="ripple-1"></span><span
                                            className="ripple-2"></span><span className="ripple-3"></span><span
                                                className="ripple-4"></span><span className="ripple-5"></span><span
                                                    className="ripple-6"></span></div>
                                        <span className="hero-subtitle fadeInLeft" data-ani="fadeInLeft" data-ani-delay="0.1s">We
                                            Create Excellence</span>
                                        <h1 className="hero-title" id="text-typing">
                                            <Typewriter options={{ strings: ['Game', 'App', 'Web'], autoStart: true, loop: true, }} />
                                            <span>Development</span>
                                        </h1>
                                        <p className="hero-text" data-ani="slideinleft" data-ani-delay="0.7s">Oengines Games LLP builds custom game, app, and web development solutions for businesses that need reliable digital products. Our developers and designers create Unity games, mobile apps, web platforms, multiplayer games, board games, and card games for multiple devices.</p>
                                        <div className="btn-group" data-ani="slideinleft" data-ani-delay="0.9s">
                                            <a href="#games" className="as-btn btn-6 style-new">DISCOVER MORE<i
                                                className="fa-regular fa-arrow-right ms-2"></i></a>
                                            <a href="/contact"
                                                className="as-btn style2">CONTACT US<i
                                                    className="fa-regular fa-arrow-right ms-2"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="as-hero-slide mt-md-30 mobile-hero-slide">
                                <div className="as-hero-bg as-hero-bg-two" data-bg-src="../assets/img/bg/hero_app.jpg" style={mystyletow}></div>
                                <div className="container mt-28">
                                    <div className="hero-style2">
                                        <div className="ripple-shape"><span className="ripple-1"></span><span
                                            className="ripple-2"></span><span className="ripple-3"></span><span
                                                className="ripple-4"></span><span className="ripple-5"></span><span
                                                    className="ripple-6"></span></div>
                                        <span className="hero-subtitle" data-ani="slideinleft" data-ani-delay="0.1s">Beyond Your
                                            Imagination</span>
                                        <h2 className="hero-title fadeInLeft" data-ani="slideinleft" data-ani-delay="0.3s">
                                            <Typewriter options={{
                                                strings: ['2D', '2.5D', '3D'], autoStart: true, loop: true
                                            }} />
                                            GAMES
                                        </h2>
                                        <p className="hero-title" data-ani="slideinleft" data-ani-delay="0.5s"> </p>
                                        <p className="hero-text" data-ani="slideinleft" data-ani-delay="0.7s">Create immersive 2D, 2.5D, and 3D games with a team experienced in gameplay, UI, multiplayer systems, and cross-platform deployment.</p>
                                        <div className="btn-group" data-ani="slideinleft" data-ani-delay="0.9s"><a href="#games"
                                            className="as-btn style-new">DISCOVER MORE<i
                                                className="fa-regular fa-arrow-right ms-2"></i></a> <a href="/contact"
                                                    className="as-btn style2">CONTACT US<i
                                                        className="fa-regular fa-arrow-right ms-2"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="as-hero-slide mt-md-30 mobile-hero-slide">
                                <div className="as-hero-bg as-hero-bg-three" data-bg-src="../assets/img/bg/hero-bg/app.jpg" style={mystylethree}></div>
                                <div className="container">
                                    <div className="hero-style2 home-art-hero">
                                        <div className="ripple-shape"><span className="ripple-1"></span><span
                                            className="ripple-2"></span><span className="ripple-3"></span><span
                                                className="ripple-4"></span><span className="ripple-5"></span><span
                                                    className="ripple-6"></span></div>

                                        <span className="hero-subtitle" data-ani="slideinleft" data-ani-delay="0.1s">Game Art & Design
                                            Studio</span>
                                        <div className="aggettivi home-art-hero__titles">
                                            <h2 className="third-slide-text text-animated-one text-white sub-hero-titles"
                                                data-ani="slideinleft" data-ani-delay="0.5s">2D Game
                                                Art</h2>
                                            <h2 className="third-slide-text text-animated-two text-white sub-hero-titles"
                                                data-ani="slideinleft" data-ani-delay="0.5s">3D Game
                                                Assets</h2>
                                            <h2 className="third-slide-text text-animated-three text-white sub-hero-titles"
                                                data-ani="slideinleft" data-ani-delay="0.5s">UI, VFX &
                                                Animation</h2>
                                        </div>
                                        <p className="hero-text" data-ani="slideinleft" data-ani-delay="0.7s">Design production-ready characters, environments, props, game UI, animations, and optimized 3D assets for mobile, PC, web, and console games.</p>

                                        <div className="btn-group" data-ani="slideinleft" data-ani-delay="0.9s"><a href="#games"
                                            className="as-btn style-new">DISCOVER MORE<i
                                                className="fa-regular fa-arrow-right ms-2"></i></a> <a href="/contact"
                                                    className="as-btn style2" >CONTACT US<i
                                                        className="fa-regular fa-arrow-right ms-2"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </OwlCarousel>                       
                    </div>
                    <div className="hero-shape2" style={{ zIndex: 10 }}><img src="assets/img/hero/hero_shape_2_2.png" alt="shape" />
                    </div>
                    <div className="hero-shape3" style={{ zIndex: 10 }}><img src="assets/img/hero/hero_shape_2_3.png" alt="shape" />
                    </div>
                </div>
                <section className="bg-top-center z-index-common space-top mt-80 space " style={mystylefive} id="games">
                    <div className="parti-one">
                        <div className="container">

                            <div className="row justify-content-lg-between justify-content-center align-items-center" >
                                <div className="col-lg-6 col-sm-9 pe-xl-5">
                                    <div className="title-area text-center text-lg-start">
                                        <div className="shadow-title color2">SERVICES</div><span className="sub-title"><img
                                            src="assets/img/theme-img/title_shape_2.svg" alt="shape" />Our Expertise</span>
                                        <h2 className="sec-title text-white our-full-services">Full-Cycle Game, App & Web
                                            <span className="text-theme"> Development Services</span></h2>
                                    </div>
                                </div>
                            </div>
                            <div className="home-services-slider">
                                <OwlCarousel className="owl-theme home-services-carousel" {...homeServicesCarousel}>
                                    {homeServices.map((service) => (
                                        <div className="home-service-card" key={service.title} role="button" tabIndex="0" onClick={() => this.openServiceShowcase(service)} onKeyDown={(event) => {
                                            if (event.key === "Enter" || event.key === " ") {
                                                event.preventDefault();
                                                this.openServiceShowcase(service);
                                            }
                                        }}>
                                            <div className="home-service-card__icon">
                                                {service.iconType === "image" ? (
                                                    <img src={service.icon} alt={service.iconAlt} />
                                                ) : (
                                                    <i className={service.icon}></i>
                                                )}
                                            </div>
                                            <h3>{service.title}</h3>
                                            <p>{service.description}</p>
                                            <div className="home-service-tags">
                                                {service.tags.map((tag) => (
                                                    <span key={tag}>{tag}</span>
                                                ))}
                                            </div>
                                            <button className="home-service-link" type="button">View Showcases<i className="fa-regular fa-arrow-right"></i></button>
                                        </div>
                                    ))}
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal
                    show={Boolean(selectedService)}
                    onHide={this.closeServiceShowcase}
                    centered
                    size="lg"
                    className="home-service-showcase-modal"
                    dialogClassName="home-service-modal-dialog"
                    backdropClassName="home-service-modal-backdrop"
                >
                    {selectedService && (
                        <div className="home-service-modal">
                            <button className="home-service-modal__close" type="button" aria-label="Close" onClick={this.closeServiceShowcase}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                            <div className="home-service-modal__header">
                                <div className="home-service-modal__icon">
                                    {selectedService.iconType === "image" ? (
                                        <img src={selectedService.icon} alt={selectedService.iconAlt} />
                                    ) : (
                                        <i className={selectedService.icon}></i>
                                    )}
                                </div>
                                <div>
                                    <span className="home-service-modal__label">Service Showcases</span>
                                    <h3>{selectedService.title}</h3>
                                    <p>{selectedService.description}</p>
                                </div>
                            </div>
                            <div className="home-service-modal__grid">
                                {selectedService.showcaseItems.map((item, index) => (
                                    <a className="home-service-showcase-box" href={item.href} key={item.title}>
                                        <span>{String(index + 1).padStart(2, "0")}</span>
                                        <strong>{item.title}</strong>
                                        <i className="fa-regular fa-arrow-right"></i>
                                    </a>
                                ))}
                            </div>
                        </div>
                    )}
                </Modal>
                <div className="space why_bg" id="about-sec">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6 mb-30 mb-xl-0">
                                <div className="img-box1">
                                    <div className="img1"><img src="assets/img/normal/faq_1_1.png" alt="About" /></div>
                                    <div className="year-counter">
                                        <img src="../assets/img/theme-img/yearexperience.svg" alt="img not found" />
                                        <h3 className="year-counter_number "><span className="counter-number" id="foo"><CountUp end={sessionStorage.getItem("yearOfExp")}/>+</span></h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="ps-xxl-4 ms-xl-3 p-4">
                                    <div className="title-area mb-35"><span className="sub-title"><img
                                        src="assets/img/theme-img/title_shape_1.svg" alt="shape" />About Oengines</span>
                                        <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                            <div className="d-flex our-sgv-flex">
                                                <div className="abt-svg-icon">
                                                    <img src="../assets/img/icon/megaphone.svg" alt="img not found" />
                                                </div>
                                                <h2 className="sec-title fadeInLeft">
                                                    <span className="">Game, App & Web Development Company</span></h2>
                                            </div>
                                        </ScrollAnimation>
                                    </div>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <p className="mt-n2 mb-25">Oengines Games LLP is a game development, mobile app development, and web development company helping businesses build reliable digital products from idea to launch. We work across Unity and Unreal games, Android and iOS apps, web platforms, backend systems, 2D/3D art, UI/UX design, QA, deployment, and long-term support.</p></ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <p className="mt-n2 mb-25">Our team combines planning, creative design, product engineering, and structured testing to deliver stable, scalable, user-ready products. Whether you need a multiplayer game, business website, mobile application, admin dashboard, cloud backend, or live operations support, we focus on clear communication and dependable execution.</p></ScrollAnimation>
                                    <div className="about-feature-wrap">
                                        <div className="about-feature">
                                            <div className="about-feature_icon"><img src="../assets/img/icon/about_feature_1_1.svg"
                                                alt="Icon" /></div>
                                            <div className="media-body">
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <h3 className="about-feature_title">Complete Product Delivery</h3>
                                                </ScrollAnimation>
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <p className="about-feature_text">Product strategy, UI/UX, development, QA, deployment, and ongoing support in one delivery workflow</p>
                                                </ScrollAnimation>
                                            </div>
                                        </div>
                                        <div className="about-feature">
                                            <div className="about-feature_icon"><img src="../assets/img/icon/about_feature_1_2.svg"
                                                alt="Icon" /></div>
                                            <div className="media-body">
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <h3 className="about-feature_title">Multi-Disciplinary Experts</h3>
                                                </ScrollAnimation>
                                                <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                                    <p className="about-feature_text">Unity developers, mobile engineers, web developers, artists, designers, QA testers, and backend specialists</p>
                                                </ScrollAnimation>
                                            </div>
                                        </div>
                                    </div>
                                    <ScrollAnimation animateIn="animate__animated animate__fadeInUp">
                                        <div className="btn-group"><a href="tel:+919427310521" className="as-btn style3">Call now<i
                                            className="fa-regular fa-arrow-right ms-2"></i></a>
                                            <div className="call-btn">
                                                <div className="play-btn"><i className="fas fa-phone"></i></div>
                                                <div className="media-body"  ><span className="btn-text">Call Us On:</span> <a
                                                    href="tel:+919427310521" className="btn-title">(+91) - 9427310521</a></div>
                                            </div>
                                        </div></ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="home-why-choose space">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-8 col-lg-10">
                                <div className="title-area text-center">
                                    <span className="sub-title"><img src="assets/img/theme-img/title_shape_2.svg" alt="shape" />WHY CHOOSE OENGINES</span>
                                    <h2 className="sec-title">Why Choose Oengines for <span className="text-theme">Digital Product Development</span></h2>
                                    <p className="mt-n2 mb-0">We bring game, mobile app, web, art, backend, QA, and support capabilities together so your project can move from idea to launch with one focused team.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4 home-why-grid">
                            <div className="col-md-6 col-xl-4">
                                <div className="home-why-card">
                                    <div className="home-why-card__icon"><i className="fa-solid fa-gamepad"></i></div>
                                    <h3>Game & Product Expertise</h3>
                                    <p>Unity games, mobile apps, web platforms, backend systems, art, animation, testing, and support handled by a product-focused team.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="home-why-card">
                                    <div className="home-why-card__icon"><i className="fa-solid fa-diagram-project"></i></div>
                                    <h3>End-to-End Execution</h3>
                                    <p>We support the full lifecycle: discovery, UI/UX, development, QA, deployment, store publishing, maintenance, and improvements.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="home-why-card">
                                    <div className="home-why-card__icon"><i className="fa-solid fa-server"></i></div>
                                    <h3>Scalable Engineering</h3>
                                    <p>Our team builds stable architecture for multiplayer games, APIs, admin dashboards, databases, cloud systems, and live products.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="home-why-card">
                                    <div className="home-why-card__icon"><i className="fa-solid fa-pen-nib"></i></div>
                                    <h3>Creative + Technical Team</h3>
                                    <p>Developers, designers, 2D/3D artists, animators, technical artists, QA testers, and backend engineers work together.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="home-why-card">
                                    <div className="home-why-card__icon"><i className="fa-solid fa-clipboard-check"></i></div>
                                    <h3>Quality-Focused Process</h3>
                                    <p>We test functionality, performance, device compatibility, usability, and edge cases to reduce risk before launch.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="home-why-card">
                                    <div className="home-why-card__icon"><i className="fa-solid fa-headset"></i></div>
                                    <h3>Post-Launch Support</h3>
                                    <p>After release, we help with bug fixes, updates, analytics, monetization, ad integration, store support, and live operations.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="home-delivery-stats space-extra pt-0">
                    <div className="container py-2">
                        <div className="project-abt-theme home-delivery-panel">
                            <div className="row gy-4 align-items-center justify-content-between">
                                <div className="col-lg-4">
                                    <div className="prd-text home-delivery-copy">
                                        <span className="home-delivery-kicker">Delivery confidence</span>
                                        <h2>Proven delivery across games, mobile apps, and web platforms</h2>
                                        <p>We help businesses launch reliable digital products that improve user engagement, operations, scalability, and revenue opportunities.</p>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="row g-3 home-delivery-counter-row">
                                        <div className="col-md-4">
                                            <div className="counter-card home-stat-card">
                                                <span className="home-stat-card__icon"><i className="fa-solid fa-diagram-project"></i></span>
                                                <h3 className="counter-card_number text-title"><span className="counter-number">850</span>+</h3>
                                                <p className="counter-card_text">Completed Projects</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="counter-card home-stat-card">
                                                <span className="home-stat-card__icon"><i className="fa-solid fa-chart-line"></i></span>
                                                <h3 className="counter-card_number text-title"><span className="counter-number">96.7</span>%</h3>
                                                <p className="counter-card_text">Satisfaction</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="counter-card home-stat-card">
                                                <span className="home-stat-card__icon"><i className="fa-solid fa-users-gear"></i></span>
                                                <h3 className="counter-card_number text-title"><span className="counter-number">26</span>+</h3>
                                                <p className="counter-card_text">Skilled Experts</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="home-delivery-points">
                                        <span>Game development</span>
                                        <span>Mobile apps</span>
                                        <span>Web platforms</span>
                                        <span>Backend & QA</span>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="home-delivery-assurance">
                                        <div>
                                            <strong>Structured delivery</strong>
                                            <span>Planning, UI/UX, development, QA, deployment, and support handled through a clear workflow.</span>
                                        </div>
                                        <div>
                                            <strong>Multi-skill execution</strong>
                                            <span>Game, web, mobile, backend, art, animation, and testing teams working together for dependable outcomes.</span>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </section>
                <section className="home-work-process space">
                    <div className="container">
                        <div className="row justify-content-between align-items-end">
                            <div className="col-xl-6 col-lg-7">
                                <div className="title-area">
                                    <span className="sub-title"><img src="assets/img/theme-img/title_shape_2.svg" alt="shape" />HOW WE WORK</span>
                                    <h2 className="sec-title">Our Product Development Process From <span className="text-theme">Idea to Launch</span></h2>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-5">
                                <p className="home-work-process__intro">We keep every project structured, visible, and practical so discovery, design, development, QA, deployment, and support move forward with fewer surprises.</p>
                            </div>
                        </div>
                        <div className="home-work-process__grid">
                            <div className="home-work-step">
                                <span className="home-work-step__number">01</span>
                                <div className="home-work-step__icon"><i className="fa-solid fa-magnifying-glass-chart"></i></div>
                                <h3>Discovery & Planning</h3>
                                <p>We understand your idea, goals, users, platforms, scope, timeline, and technical requirements.</p>
                            </div>
                            <div className="home-work-step">
                                <span className="home-work-step__number">02</span>
                                <div className="home-work-step__icon"><i className="fa-solid fa-pen-ruler"></i></div>
                                <h3>Design & Architecture</h3>
                                <p>We prepare UI/UX, game flow, system architecture, database/API planning, and the delivery roadmap.</p>
                            </div>
                            <div className="home-work-step">
                                <span className="home-work-step__number">03</span>
                                <div className="home-work-step__icon"><i className="fa-solid fa-code"></i></div>
                                <h3>Development</h3>
                                <p>Our team builds the game, app, website, backend, dashboard, art, animation, and integrations.</p>
                            </div>
                            <div className="home-work-step">
                                <span className="home-work-step__number">04</span>
                                <div className="home-work-step__icon"><i className="fa-solid fa-shield-check"></i></div>
                                <h3>Testing & Optimization</h3>
                                <p>We test functionality, performance, devices, usability, edge cases, bugs, and launch readiness.</p>
                            </div>
                            <div className="home-work-step">
                                <span className="home-work-step__number">05</span>
                                <div className="home-work-step__icon"><i className="fa-solid fa-rocket"></i></div>
                                <h3>Launch & Support</h3>
                                <p>We help with deployment, store publishing, cloud setup, monitoring, updates, analytics, and support.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="space" id="contact-sec" data-bg-src="assets/img/bg/appointment_bg_1.jpg" style={mystylesix}>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 pe-xxl-5 mb-40 mb-xl-0">
                                <div className="title-area mb-35 text-xl-start text-center"><span className="sub-title"><img
                                    src="assets/img/theme-img/title_shape_1.svg" alt="shape" />GET IN TOUCH</span>
                                    <h2 className="sec-title">Ready to Build Your Game, App, or Web Project<span
                                        className="text-theme"> With Oengines?</span></h2>
                                </div>
                                <p className="mt-n2 mb-30 text-xl-start text-center">Share your idea, requirement, or technical challenge. Our team will review it and help you plan the right technology, scope, timeline, and next step.</p>
                                <p className="mt-n2 mb-30 text-xl-start text-center">Tell us what you want to build and we will respond with practical guidance for your game, app, website, backend, or digital product.</p>
                                <div className="contact-feature-wrap">
                                    <div className="contact-feature">
                                        <div className="icon-btn"><i className="fa-solid fa-phone"></i></div>
                                        <div className="media-body">
                                            <p className="contact-feature_label">Call Us On:</p><a href="tel:(0261) - 4054978
"
                                                className="contact-feature_link">(0261) - 4054978
                                            </a>
                                        </div>
                                    </div>
                                    <div className="contact-feature">
                                        <div className="icon-btn"><i className="fa-solid fa-envelope"></i></div>
                                        <div className="media-body">
                                            <p className="contact-feature_label">Quick Mail Us:</p><a href="mailto:support@oengines.com"
                                                className="contact-feature_link">support@oengines.com</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 ps-xl-4 home-contact-form-col">
                                
                                <ConsultationForm
                                    className="home-consultation-form"
                                    buttonClassName="as-btn style3"
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="bg-bottom-right position-relative" style={mystylefour} data-bg-color="#080E1C">
                    <div className="img-half img-left as-video2">
                        <img src="assets/img/normal/cta_1.jpg" alt="video" />
                        <p className="play-btn popup-video" id="" onClick={(e) => this.handlevideopopup(e)}><i
                            className="fas fa-play vid-play"></i>
                        </p>
                    </div>
                    <div className="container">
                        <div className="row justify-content-end" >
                            <div className="col-xl-7 space" id="half-particles">
                                <div className="title-area mb-35">
                                    <span className="sub-title"><img
                                        src="assets/img/theme-img/title_shape_1.svg" alt="shape" />WATCH THE VIDEO</span>
                                    <h2 className="sec-title text-white">We Build Games, Apps & Digital Products That Stand Out</h2>
                                </div>
                                <p className="mt-n2 mb-30 text-white">Choosing the right development partner matters. At Oengines, we combine game design, engineering, art, animation, QA, and backend expertise to build products that are reliable, engaging, and ready to scale.</p>
                                <p className="mt-n2 mb-30 text-white">From mobile games and web platforms to multiplayer systems and live product support, our team focuses on clean execution, strong visuals, and smooth user experiences.</p>

                                <button className="as-btn" id="" onClick={(e) => this.openModal(e)} style={{ border: "none" }}>GET A QUOTE
                                    <i className="fa-regular fa-arrow-right ms-2"></i>
                                </button>

                            </div>
                        </div>
                    </div>

                </section>
                <section className="" style={{ backgroundColor: "#1c1c1c" }}>
                    <div className="z-index-common">
                        <div className="row justify-content-center m-0">
                            <div className="col-lg-6 col-md-6 col-sm-10  px-xl-4">
                                <div className="title-area text-center pt-20 mt-40"><span className="sub-title"><img
                                    src="assets/img/theme-img/title_shape_1.svg" alt="shape" />OUR TECHNICAL EXPERTISE</span>
                                    <h2 className="sec-title text-white set-max_height">Technology Stack Built for <span className="text-theme">Games, Apps & Web Platforms</span></h2>
                                    <p className="mt-n2 mb-30 text-white pt-40 m-auto">We use proven engines, frameworks, cloud tools, and production workflows to build scalable games, mobile apps, web platforms, backend systems, and immersive digital experiences.

                                        </p><p className="mt-n2 text-white m-auto txt-600">From Unity and Unreal to React, Node.js, mobile, cloud, QA, and live operations, our team brings the right technical depth for complete product delivery.</p>
                                </div>
                            </div>
                            <div className="main-lan col-auto">
                                <div className="content-ln">
                                    <div className=" d-block conetnt-ln-inner">

                                        <div className="service-featured">
                                            <div className="service-featured_content animate-one">
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="col-md-6 col-sm-8 col-xxl-6 Icon_img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="col-md-6 col-sm-6 col-xxl-6 Icon_img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="col-md-6 col-sm-6 col-xxl-6 Icon_img-three" />
                                            </div>
                                            <div className="service-featured_content animate-one">
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="col-md-6 col-sm-8 col-xxl-6 Icon_img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="col-md-6 col-sm-8 col-xxl-6 Icon_img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="col-md-6 col-sm-6 col-xxl-6 Icon_img-three" />
                                            </div>
                                        </div>

                                    </div>                                    
                                </div>
                            </div>
                            <div className="main-lan col-md-12 new_main_lan">
                                <div className="row content-ln d-flex">
                                    <div className="service-featured">
                                        <div className="service-featured_content animate-one">
                                            <div>
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="img-three" />
                                            </div>
                                            <div>
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="img-three" />
                                            </div>
                                            <div>
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="img-three" />
                                            </div>
                                            <div>
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="img-three" />
                                            </div>
                                            <div>
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="img-three" />
                                            </div>
                                            <div>
                                                <img src="assets/img/techs/new_k.png" alt="Icon" className="img-one" />
                                                <img src="assets/img/techs/new_kk.png" alt="Icon" className="img-two" />
                                                <img src="assets/img/techs/kkk.png" alt="Icon" className="img-three" />
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="space-bottom space-top contact-infos pb-0">
                    <div className="container">
                        <div className="row text-center pt-4">
                            <div className="col">
                                <h2 className="word-rotator slide font-weight-bold text-8 mb-25">
                                    <span>We're not the only ones&nbsp;</span>
                                    <span className="word-rotator-words bg-primary">
                                        <span className="spinny-words text-start">
                                            <span>excited</span>
                                            <span>happy</span>
                                            <span>excited</span>
                                            <span>happy</span>
                                            <span>excited</span>
                                            <span>happy</span>
                                        </span>                                      
                                    </span>
                                    <span>&nbsp;about Game Development.</span>
                                </h2>
                                <h4 className="text-primary lead tall text-4">7M CUSTOMERS IN 100 COUNTRIES USE OENGINES GAMES.</h4>
                            </div>
                        </div>
                        <div className="row text-center mt-5">
                            <div>
                                <OwlCarousel className='owl-theme' loop margin={10} {...sliderSettings} nav>
                                    <div>
                                        <img src="assets/img/language/logo-1.png" alt="img not found" />
                                    </div>
                                    <div>
                                        <img src="assets/img/language/logo-2.png" alt="img not found" />
                                    </div>
                                    <div>
                                        <img src="assets/img/language/logo-3.png" alt="img not found" />
                                    </div>
                                    <div>
                                        <img src="assets/img/language/logo-4.png" alt="img not found" />
                                    </div>
                                    <div>
                                        <img src="assets/img/language/logo-5.png" alt="img not found" />
                                    </div>
                                    <div>
                                        <img src="assets/img/language/logo-6.png" alt="img not found" />
                                    </div>
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* <section className="section section-custom-map appear-animation lazyloaded animated fadeInUpShorter appear-animation-visible mb-50" data-appear-animation="fadeInUpShorter" data-src-bg="img/map.png" style={{ backgroundColor: "transparent", backgroundPosition: "center 0px", backgroundRepeat: "no-repeat", animationdelay: "100ms" }}>
                    {
                        this.state.blog.length > 0 || this.state.clientfidback.length > 0 
                        ?
                            <section className="section section-default section-footer mb-80">
                                <div className="container">
                                    <div className="row mt-5 pt-3 appear-animation animated fadeInUpShorter appear-animation-visible" data-appear-animation="fadeInUpShorter">
                                        {this.state.blog.length ? 
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="recent-posts mb-5">
                                                <h2 className="font-weight-normal text-6 mb-4"><strong className="font-weight-extra-bold">Latest</strong> Posts</h2>
                                                {latestpostdata}
                                            </div>
                                        </div>
                                        :''
                                        }
                                        { this.state.clientfidback.length ? <div className="col-lg-6 col-md-6 col-sm-12">
                                            <h2 className="font-weight-normal text-6 mb-4"><strong className="font-weight-extra-bold">What</strong> Client’s Say</h2>
                                            <div className="row">
                                                {clientfideback}
                                            </div>
                                        </div>
                                        : ''
                                        }
                                    </div>
                                </div>
                            </section>
                        :
                        ''
                    }
                </section> */}
                {/* <div className="pb" id="pb"></div> */}
                <div className="pc">
                    <div className="ol">
                        <a href="#" id="btn-back-to-top">
                            <i className="fa-solid fa-arrow-up">
                            </i>
                        </a>
                    </div>
                    <div className="bg" id="bg"></div>
                </div>


                <Footer apiHeaderData={apiHeaderData} apiCareerData={apiCareerData}/>

            </div>
        )
    }
}

export default App;
